module.exports = __webpack_public_path__ + "static/dexterlee-d21a6937d8a15cbb8335b6a1a94f6351.png";